import {
  ACCOUNT_TYPE,
  ATTACHMENT_TYPE,
  CONTRACT_STATUS,
  DOCUMENT_TYPE,
  EDUCATION_LEVEL,
  HIERARCHY_LEVEL,
  KINSHIP_LEVEL,
  MARGIN_TYPE,
  PLANS_TYPE,
  PRESTAMISTA_STATUS,
  PRODUCT_STATUS,
  PRODUCT_TYPE,
  REASON_CONTRACT_CANCELATION,
  DUE_DATE_RULE,
  REGISTRATION_PENDENCY_TYPE,
  SIAPE_BOND_TYPE,
} from "./enums";

export const CONTRACT_STATUS_DISPLAY: Record<CONTRACT_STATUS, string> = {
  [CONTRACT_STATUS.DIGITACAO]: "Digitação",
  [CONTRACT_STATUS.AGUARDANDO_FORMALIZACAO]: "Aguardando Formalização",
  [CONTRACT_STATUS.FORMALIZADO]: "Formalizado",
  [CONTRACT_STATUS.MESA]: "Mesa",
  [CONTRACT_STATUS.EM_AVERBACAO]: "Em Averbação",
  [CONTRACT_STATUS.PAGO]: "Pago",
  [CONTRACT_STATUS.CANCELADO]: "Cancelado",
};

export const DOCUMENT_TYPE_DISPLAY: Record<DOCUMENT_TYPE, string> = {
  [DOCUMENT_TYPE.RG]: "RG",
  [DOCUMENT_TYPE.CNH]: "CNH",
  [DOCUMENT_TYPE.OUTROS]: "Outros",
};

export const ATTACHMENT_TYPE_DISPLAY: Record<ATTACHMENT_TYPE, string> = {
  [ATTACHMENT_TYPE.CNH]: "CNH - Cliente",
  [ATTACHMENT_TYPE.DOCUMENTO_FRENTE]: "Documento Frente - Cliente",
  [ATTACHMENT_TYPE.DOCUMENTO_VERSO]: "Documento Verso - Cliente",
  [ATTACHMENT_TYPE.SELFIE]: "Selfie",
  [ATTACHMENT_TYPE.CONTRACHEQUE]: "Contracheque",
  [ATTACHMENT_TYPE.DOCUMENTOS_ADICIONAIS]: "Documento Adicional",
  [ATTACHMENT_TYPE.COMPROVANTE_DE_ENDERECO]: "Comprovante de Endereço",
  [ATTACHMENT_TYPE.COMPROVANTE_FINANCEIRO]: "Comprovante Financeiro",
  [ATTACHMENT_TYPE.REPASSE]: "Repasse",
  [ATTACHMENT_TYPE.CCB]: "CCB",
  [ATTACHMENT_TYPE.FRENTE_CNH]: "CNH Frente",
  [ATTACHMENT_TYPE.VERSO_CNH]: "CNH Verso",
  [ATTACHMENT_TYPE.TERMO_E_ASSINATURAS]: "Termos, CCB",
  [ATTACHMENT_TYPE.DOCUMENTO_ASSINADO_FISICAMENTE]:
    "Termos, CCB -  Assinado Fisicamente",
  [ATTACHMENT_TYPE.ARQUIVO_RETORNO_RESERVA]: "Arquivo Retorno Reserva",
  [ATTACHMENT_TYPE.FOTO_PROVA_DE_VIDA]: "Foto Prova de Vida",
  [ATTACHMENT_TYPE.DOCUMENTO_FRENTE_ROGADO]: "RG Frente - Rogado",
  [ATTACHMENT_TYPE.DOCUMENTO_VERSO_ROGADO]: "RG Verso - Rogado",
  [ATTACHMENT_TYPE.CNH_ROGADO]: "CNH - Rogado",
  [ATTACHMENT_TYPE.CNH_REPRESENTANTE_LEGAL]: "CNH - Representante Legal",
  [ATTACHMENT_TYPE.DOCUMENTO_FRENTE_REPRESENTANTE_LEGAL]:
    "RG Frente - Representante Legal",
  [ATTACHMENT_TYPE.DOCUMENTO_VERSO_REPRESENTANTE_LEGAL]:
    "RG Verso - Representante Legal",
  [ATTACHMENT_TYPE.DOCUMENTO_FRENTE_TESTEMUNHA_1]: "RG Frente",
  [ATTACHMENT_TYPE.DOCUMENTO_VERSO_TESTEMUNHA_1]: "RG Verso",
  [ATTACHMENT_TYPE.CNH_TESTEMUNHA_1]: "CNH",
  [ATTACHMENT_TYPE.DOCUMENTO_FRENTE_TESTEMUNHA_2]: "RG Frente",
  [ATTACHMENT_TYPE.DOCUMENTO_VERSO_TESTEMUNHA_2]: "RG Verso",
  [ATTACHMENT_TYPE.CNH_TESTEMUNHA_2]: "CNH",
  [ATTACHMENT_TYPE.DOCUMENTO_ASSINADO_FISICAMENTE_PORTABILIDADE]:
    "CCB Assinada Fisicamente - Portabilidade",
  [ATTACHMENT_TYPE.DOCUMENTO_ASSINADO_FISICAMENTE_REFINANCIAMENTO]:
    "CCB Assinada Fisicamente - Refinanciamento",
  [ATTACHMENT_TYPE.SELFIE_REFORMALIZACAO]: "Selfie Reformalização",
  [ATTACHMENT_TYPE.EXTRATO_BANCARIO]: "Extrato bancário (últimos 60 dias)",
  [ATTACHMENT_TYPE.HISTORICO_DEBITO_CONVENIO]: "Histórico de débito",
  [ATTACHMENT_TYPE.COMPROVANTE_RENDA]: "Comprovante de renda",
};

export const PRODUCT_STATUS_DISPLAY: Record<PRODUCT_STATUS, string> = {
  // CARTAO BENEFÍCIO
  [PRODUCT_STATUS.ANDAMENTO_SIMULACAO]: "Simulação",
  [PRODUCT_STATUS.ANDAMENTO_FORMALIZACAO]: "Formalização",
  [PRODUCT_STATUS.APROVADA_FINALIZADA]: "Aprovada - Finalizada",
  [PRODUCT_STATUS.REPROVADA_FINALIZADA]: "Reprovada - Finalizada",
  [PRODUCT_STATUS.CHECAGEM_MESA_FORMALIZACAO]: "Checagem - Mesa Formalização",
  [PRODUCT_STATUS.APROVADA_MESA_FORMALIZACAO]: "Aprovada - Mesa Formalização",
  [PRODUCT_STATUS.REPROVADA_MESA_FORMALIZACAO]: "Reprovada - Mesa Formalização",
  [PRODUCT_STATUS.PENDENTE_DOCUMENTACAO]: "Pendente Documentação",
  [PRODUCT_STATUS.EM_AVERBACAO]: "Em averbação",
  [PRODUCT_STATUS.APROVADA_AVERBACAO]: "Aprovada - Averbação",
  [PRODUCT_STATUS.RECUSADA_AVERBACAO]: "Recusada - Averbação",
  [PRODUCT_STATUS.ANDAMENTO_EMISSAO_CARTAO]: "Andamento - Emissão cartão",
  [PRODUCT_STATUS.FINALIZADA_EMISSAO_CARTAO]: "Finalizada - Emissão cartão",
  [PRODUCT_STATUS.ANDAMENTO_LIBERACAO_SAQUE]:
    "Andamento - Liberação Pagamento Saque",
  [PRODUCT_STATUS.FINALIZADA_LIBERACAO_SAQUE]:
    "Finalizado - Liberação Pagamento Saque",
  [PRODUCT_STATUS.PENDENTE_CORRECAO_DADOS_BANCARIOS]:
    "Pendente - Correção de dados bancários",

  // PORTABILIDADE
  [PRODUCT_STATUS.AGUARDA_ENVIO_LINK]: "Aguarda envio link",
  [PRODUCT_STATUS.FORMALIZACAO_CLIENTE]: "Formalização",
  [PRODUCT_STATUS.ANALISE_DE_CREDITO]: "Análise de crédito (Bureaus)",
  [PRODUCT_STATUS.PENDENTE_DADOS_DIVERGENTES]: "Pendente - Dados Divergentes",
  [PRODUCT_STATUS.REPROVADA_POLITICA_INTERNA]: "Reprovada - Política Interna",
  [PRODUCT_STATUS.CHECAGEM_MESA_CORBAN]: "Checagem - Mesa Corban",
  [PRODUCT_STATUS.PENDENTE_DOCUMENTACAO_MESA_CORBAN]:
    "Pendente Documentação - Mesa Corban",
  [PRODUCT_STATUS.REPROVADA_MESA_CORBAN]: "Reprovada - Mesa Corban",
  [PRODUCT_STATUS.APROVADA_MESA_CORBAN]: "Aprovada - Mesa Corban",
  [PRODUCT_STATUS.CHECAGEM_MESA_DE_FORMALIZACAO]:
    "Checagem - Mesa de Formalização",
  [PRODUCT_STATUS.APROVADA_MESA_DE_FORMALIZACAO]:
    "Aprovada - Mesa de Formalização",
  [PRODUCT_STATUS.REPROVADA_MESA_DE_FORMALIZACAO]:
    "Reprovada - Mesa de Formalização",
  [PRODUCT_STATUS.AGUARDA_RETORNO_SALDO]: "Aguarda Retorno Saldo",
  [PRODUCT_STATUS.SALDO_RETORNADO]: "Saldo Retornado",
  [PRODUCT_STATUS.INT_CONFIRMA_PAGAMENTO]: "Int - Confirma pagamento",
  [PRODUCT_STATUS.SALDO_REPROVADO]: "Saldo Reprovado",
  [PRODUCT_STATUS.REPROVADA_PAGAMENTO_DEVOLVIDO]:
    "Reprovada - Pagamento Devolvido",
  [PRODUCT_STATUS.INT_AGUARDA_AVERBACAO]: "Int - Aguarda Averbação",
  [PRODUCT_STATUS.INT_FINALIZADO]: "Int - Finalizado",
  [PRODUCT_STATUS.INT_AVERBACAO_PENDENTE]: "Int - Averbação Pendente",

  // CARTAO NOVOS
  [PRODUCT_STATUS.ERRO_SOLICITACAO_SAQUE]: "Erro - Transmissão do Contrato",

  // PORTABILIDADE IN100
  [PRODUCT_STATUS.REPROVADO]: "Reprovado",
  [PRODUCT_STATUS.AGUARDANDO_RETORNO_IN100]: "Aguardando Retorno da IN100",

  // NOVO STATUS
  [PRODUCT_STATUS.AGUARDANDO_IN100_RECALCULO]:
    "Aguardando Consulta IN100 (Recalculo)",
  [PRODUCT_STATUS.RETORNO_IN100_RECALCULO_RECEBIDO]:
    "IN100 Consultada no Recalculo",

  [PRODUCT_STATUS.REVISAO_MESA_DE_FORMALIZACAO]:
    "Revisão - Mesa de Formalização",
  [PRODUCT_STATUS.REPROVADA_REVISAO_MESA_DE_FORMALIZACAO]:
    "Reprovada Revisão - Mesa de Formalização",
  [PRODUCT_STATUS.AVERBACAO_MESA_DE_FORMALIZACAO]:
    "Averbação - Mesa de Formalização",

  [PRODUCT_STATUS.SAQUE_CANCELADO_LIMITE_DISPONIVEL_INSUFICIENTE]:
    "Saque Cancelado - Limite disponível Insuficiente",
  [PRODUCT_STATUS.SAQUE_RECUSADO_PROBLEMA_PAGAMENTO]:
    "Saque Recusado - Problema no Pagamento",

  [PRODUCT_STATUS.ANDAMENTO_REAPRESENTACAO_DO_PAGAMENTO_DE_SAQUE]:
    "Andamento - Reapresentação do pagamento de saque",
  [PRODUCT_STATUS.PENDENCIADO]: "Pendenciado",

  [PRODUCT_STATUS.ANDAMENTO_CHECAGEM_DATAPREV]:
    "Em Andamento – Consulta Dataprev",
  [PRODUCT_STATUS.ERRO_CONSULTA_DATAPREV]: "Erro – Consulta Dataprev",
  [PRODUCT_STATUS.REPROVADO_CONSULTA_DATAPREV]: "Reprovado – Consulta Dataprev",

  [PRODUCT_STATUS.AGUARDANDO_AVERBACAO_REFIN]:
    "Aguardando Averbação Refinanciamento",
  [PRODUCT_STATUS.AGUARDANDO_DESEMBOLSO_REFIN]: "Aguardando Desembolso Refin",
  [PRODUCT_STATUS.AGUARDANDO_FINALIZAR_PORT]:
    "Aguardando Finalizar Portabilidade",
  [PRODUCT_STATUS.INT_FINALIZADO_DO_REFIN]: "Int - Finalizado do Refin",

  [PRODUCT_STATUS.ERRO_CRIACAO_CARTAO]: "Erro - Criação do Cartão",
  [PRODUCT_STATUS.PENDENTE_APROVACAO_RECALCULO_CORBAN]:
    "Pendente Aprovação Recalculo Corban",
  [PRODUCT_STATUS.CHECAGEM_MESA_DE_AVERBECAO]: "Checagem - Mesa de Averbação",
  [PRODUCT_STATUS.AGUARDA_FINALIZACAO_PROPOSTA_PRINCIPAL]:
    "Ag. finalização proposta principal",
  [PRODUCT_STATUS.REPROVADA_MESA_DE_AVERBECAO]: "Reprovada - Mesa de Averbação",
  [PRODUCT_STATUS.INT_AJUSTE_AVERBACAO]: "Int - Ajuste Averbação",
  [PRODUCT_STATUS.VALIDACOES_AUTOMATICAS]: "Validações Automáticas",
  [PRODUCT_STATUS.AGUARDANDO_DESEMBOLSO]: "Aguardando Desembolso",
  [PRODUCT_STATUS.INT_AGUARDANDO_PAGO_QITECH]:
    "Int - Aguardando pago da QiTech",
  [PRODUCT_STATUS.PENDENCIAS_AVERBACAO_CORBAN]:
    "Pendências para Averbação – Corban",
  [PRODUCT_STATUS.REGULARIZADA_MESA_AVERBACAO]:
    "Regularizada Averbação – Mesa de Averbação",
  [PRODUCT_STATUS.FINALIZADA_FORMALIZACAO_CLIENTE]:
    "Finalizada Formalização Cliente",
  [PRODUCT_STATUS.FINALIZADA_FORMALIZACAO_ROGADO]:
    "Finalizada Formalização Rogado",
  [PRODUCT_STATUS.AGUARDANDO_FIM_MACICA]: "Aguardando Fim Maciça",
  [PRODUCT_STATUS.CHECAGEM_MESA_VIDEO]: "Aguardando vídeo chamada do cliente",

  [PRODUCT_STATUS.TEIMOSINHA_DATAPREV]: "Teimosinha Dataprev - Averbação",

  [PRODUCT_STATUS.APROVADA_VIDEO_CHAMADA]: "Aprovada - Vídeo Chamada",
  [PRODUCT_STATUS.REPROVADO_VIDEO_CHAMADA]: "Reprovado – Formalização em Vídeo",
  [PRODUCT_STATUS.PENDENCIADO_VIDEO_CHAMADA]:
    "Pendente esclarecimentos com o cliente",

  [PRODUCT_STATUS.CHECAGEM_AVERBACAO_CONECTA]: "Checagem - Averbação Conecta",
  [PRODUCT_STATUS.APROVADA_AVERBACAO_CONECTA]: "Aprovada - Averbação Conecta",
  [PRODUCT_STATUS.PENDENCIADO_AVERBACAO_CONECTA]:
    "Pendenciado - Averbação Conecta",
  [PRODUCT_STATUS.REGULARIZADA_AVERBACAO_CONECTA]:
    "Regularizada - Averbação Conecta",
  [PRODUCT_STATUS.REPROVADO_AVERBACAO_CONECTA]: "Reprovado - Averbação Conecta",
  [PRODUCT_STATUS.APROVADO_PRICING]: "Aprovado pelo Pricing",
  [PRODUCT_STATUS.RECALCULO_PRICING]:
    "Recálculo Pricing - aguardando avaliação",
  [PRODUCT_STATUS.RECALCULO_REFINANCIAMENTO]: "Recálculo do Refinanciamento",

  [PRODUCT_STATUS.REFORMALIZACAO_CLIENTE]: "Reformalização Cliente",
  [PRODUCT_STATUS.PROPOSTA_CANCELADA_PELO_CORBAN]:
    "Proposta cancelada pelo corban",
  [PRODUCT_STATUS.APROVADO_REFORMALIZACAO]: "Aprovado Reformalização",
  [PRODUCT_STATUS.CHECAGEM_MESA_SALDO]: "Checagem - Mesa Saldo",
  [PRODUCT_STATUS.APROVADO_AUTOMATICAMENTE_MESA_FORMALIZACAO]:
    "Aprovado automaticamente - Mesa de Formalização",
  [PRODUCT_STATUS.TAXA_COMISSAO_COBYX_REALIZADA]:
    "Taxa de Comissão Cobyx Realizada",
  [PRODUCT_STATUS.ERRO_TAXA_COMISSAO_COBYX]: "Erro - Taxa de Comissão Cobyx",
  [PRODUCT_STATUS.RECUSADA_AVERBACAO_SIAPE]: "Recusada - Averbação SIAPE",
  [PRODUCT_STATUS.RECUSADA_AVERBACAO_CLIENTE]: "Recusada - Averbação Cliente",
  [PRODUCT_STATUS.AGUARDANDO_ACEITE_CLIENTE_AVERBACAO]:
    "Aguardando aceite do cliente para averbação",
  [PRODUCT_STATUS.CANCELADO]: "Cancelado",
  [PRODUCT_STATUS.ANDAMENTO_ANALISE_OPERACIONAL]: "Análise Operacional",
  [PRODUCT_STATUS.ANALISE_TECNICA]: "Análise Tecnica",
  [PRODUCT_STATUS.PENDENTE_VALIDACAO_PARCELA]: "Pendente Validação Parcela",
  [PRODUCT_STATUS.PARCELA_AJUSTADA]: "Parcela Ajustada",
  [PRODUCT_STATUS.FINALIZADO_LIQUIDACAO_SAQUE]: "Finalizada Liquidação Saque",
  [PRODUCT_STATUS.PROPOSTA_REPRESADA]: "Proposta Represada",

  // AGREGACAO DE MARGEM CARTAO
  [PRODUCT_STATUS.EM_ANDAMENTO_ALTERACAO_LIMITE]:
    "Em Andamento Alteração Limite",
  [PRODUCT_STATUS.FINALIZADO_ALTERACAO_LIMITE]: "Finalizado Alteração Limite",
  [PRODUCT_STATUS.REPROVADO_ALTERACAO_LIMITE]: "Reprovado Alteração Limite",

  // RECEBA
  [PRODUCT_STATUS.AGUARDANDO_VALIDACAO_CORBAN]: "Aguardando Validação",
  [PRODUCT_STATUS.AGUARDANDO_ARQUIVO_OPTANTE]: "Aguardando Arquivo do Optante",
  [PRODUCT_STATUS.REPORVADO_RECALCULO_SCD]: "Reprovado - Recalculo da SCD",
  [PRODUCT_STATUS.ARQUIVO_OPTANTE_RETORNADO]: "Arquivo do Optante Retornado",
  [PRODUCT_STATUS.APROVADO_RECALCULO_SCD]: "Aprovado - Recalculo da SCD",
  [PRODUCT_STATUS.TEIMOSINHA_IN100]: "Teimosinha IN100",
  [PRODUCT_STATUS.TEIMOSINHA_IN100_ENVIADO]: "Teimosinha IN100 - Enviado",

  // AUMENTO DE MARGEM
  [PRODUCT_STATUS.AGUARDANDO_AVERBACAO_AUMENTO_MARGEM]:
    "Aguardando averbação - Aumento de margem",
  [PRODUCT_STATUS.DIGITACAO]: "Proposta em Digitação",
  [PRODUCT_STATUS.GERACAO_PROPOSTA]: "Geração da Proposta (CCB)",

  [PRODUCT_STATUS.REFIN_CANCELADO]: "Refinanciamento Cancelado",
  [PRODUCT_STATUS.AGUARDANDO_IN100_FURAFILA]: "Aguardando IN100 (Fura Fila)",
  [PRODUCT_STATUS.AGUARDANDO_ENVIO_SALDO_REPRESADO]:
    "Aguardando Envio de Saldo - Represado",
  [PRODUCT_STATUS.AVERBADO_AGUARDANDO_ANUENCIA]:
    "Averbado - Aguardando Anuência",
};

export const PRODUCT_TYPE_DISPLAY: Record<PRODUCT_TYPE, string> = {
  [PRODUCT_TYPE.FGTS]: "FGTS",
  [PRODUCT_TYPE.INSS_REPRESENTANTE_LEGAL]: "INSS (Com representante legal)",
  [PRODUCT_TYPE.CARTAO_BENEFICIO_REPRESENTANTE]:
    "Cartão Benefício (Com representante legal)",
  [PRODUCT_TYPE.PAB]: "PAB",
  [PRODUCT_TYPE.INSS_CORBAN]: "INSS Corban",
  [PRODUCT_TYPE.INSS]: "INSS",
  [PRODUCT_TYPE.CARTAO_BENEFICIO]: "Cartão Benefício",
  [PRODUCT_TYPE.SIAPE]: "SIAPE",
  [PRODUCT_TYPE.EXERCITO]: "Exército",
  [PRODUCT_TYPE.MARINHA]: "Marinha",
  [PRODUCT_TYPE.AERONAUTICA]: "Aeronáutica",
  [PRODUCT_TYPE.PORTABILIDADE]: "Portabilidade",
  [PRODUCT_TYPE.CONSIGNADO]: "Consignado",
  [PRODUCT_TYPE.SAQUE_COMPLEMENTAR]: "Saque Complementar",
  [PRODUCT_TYPE.CARTAO_CONSIGNADO]: "Cartão Consignado",
  [PRODUCT_TYPE.MARGEM_LIVRE]: "Margem Livre",
  [PRODUCT_TYPE.MARGEM_LIVRE_AUMENTO]: "Aumento Salarial",
  [PRODUCT_TYPE.PORTABILIDADE_REFIN]: "Portabilidade + Refinanciamento",
  [PRODUCT_TYPE.REFINANCIAMENTO]: "Refinanciamento",
  [PRODUCT_TYPE.REFIN_CARTAO]: "Refin Saque Cartão",
  [PRODUCT_TYPE.TODOS_PRODUTOS]: "Todos produtos",
  [PRODUCT_TYPE.AGREGACAO_MARGEM]: "Agregação de Margem Cartão",
  [PRODUCT_TYPE.RECEBA]: "Receba",
  [PRODUCT_TYPE.CONSIGNADO_PRIVADO]: "Consignado Privado",
};

export const MARGIN_TYPE_DISPLAY: Record<MARGIN_TYPE, string> = {
  [MARGIN_TYPE.MARGEM_COMPRA]: "Margem Compra",
  [MARGIN_TYPE.MARGEM_SAQUE]: "Margem Saque",
  [MARGIN_TYPE.MARGEM_UNICA]: "Margem Única",
  [MARGIN_TYPE.MARGEM_UNIFICADA]: "Margem Unificada",
};

export const PLANS_TYPE_DISPLAY: Record<PLANS_TYPE, string> = {
  [PLANS_TYPE.DIAMANTE]: "Diamante",
  [PLANS_TYPE.OURO]: "Ouro",
  [PLANS_TYPE.PRATA]: "Prata",
};

export const HIERARCHY_LEVEL_DISPLAY: Record<HIERARCHY_LEVEL, string> = {
  [HIERARCHY_LEVEL.ADMINISTRADOR]: "Administrador",
  [HIERARCHY_LEVEL.GERENTE]: "Gerente",
  [HIERARCHY_LEVEL.SUPERVISOR]: "Supervisor",
  [HIERARCHY_LEVEL.DONO_LOJA]: "Dono da Loja",
  [HIERARCHY_LEVEL.DIGITADOR]: "Digitador",
};

export const REGISTRATION_PENDENCY_TYPE_DISPLAY: Record<
  REGISTRATION_PENDENCY_TYPE,
  string
> = {
  [REGISTRATION_PENDENCY_TYPE.SENHA_DE_AVERBACAO]: "Senha de averbação",
  [REGISTRATION_PENDENCY_TYPE.CONTRACHEQUE]: "Contracheque",
  [REGISTRATION_PENDENCY_TYPE.DEMAIS_ANEXOS_DE_AVERBACAO]:
    "Demais anexos de averbação",
};

export const EDUCATION_LEVEL_DISPLAY: Record<EDUCATION_LEVEL, string> = {
  [EDUCATION_LEVEL.FUNDAMENTAL]: "Ensino Fundamental",
  [EDUCATION_LEVEL.MEDIO]: "Ensino Médio",
  [EDUCATION_LEVEL.SUPERIOR]: "Ensino Superior",
  [EDUCATION_LEVEL.POS_GRADUADO]: "Pós Graduado",
  [EDUCATION_LEVEL.ANALFABETO]: "Analfabeto",
};

export const KINSHIP_LEVEL_DISPLAY: Record<KINSHIP_LEVEL, string> = {
  [KINSHIP_LEVEL.CONJUGE]: "Cônjuge",
  [KINSHIP_LEVEL.FILHO]: "Filho(a)",
  [KINSHIP_LEVEL.PAI]: "Pai",
  [KINSHIP_LEVEL.MAE]: "Mãe",
  [KINSHIP_LEVEL.IRMAO]: "Irmão(ã)",
};

export const ACCOUNT_TYPE_DISPLAY: Record<ACCOUNT_TYPE, string> = {
  [ACCOUNT_TYPE.CONTA_CORRENTE_PESSOA_FISICA]: "Conta Corrente Pessoa Física",
  [ACCOUNT_TYPE.CONTA_POUPANCA_PESSOA_FISICA]: "Conta Poupança Pessoa Física",
  [ACCOUNT_TYPE.CONTA_PAGAMENTO_PESSOA_FISICA]: "Conta Pagamento Pessoa Física",
  [ACCOUNT_TYPE.CONTA_CORRENTE_PESSOA_JURIDICA]:
    "Conta Corrente Pessoa Jurídica",
  [ACCOUNT_TYPE.CARTAO_MAGNETICO]: "Cartão Magnético",
};

export const SIAPE_BOND_TYPE_DISPLAY: Record<SIAPE_BOND_TYPE, string> = {
  [SIAPE_BOND_TYPE.SERVIDOR]: "Servidor",
  [SIAPE_BOND_TYPE.PENSIONISTA]: "Pensionista",
};

export const REASON_CONTRACT_CANCELATION_DISPLAY: Record<
  REASON_CONTRACT_CANCELATION,
  string
> = {
  [REASON_CONTRACT_CANCELATION.DESISTENCIA_CLIENTE]: "Desistência do cliente",
  [REASON_CONTRACT_CANCELATION.FORMALIZACAO_EXPIRADA]: "Formalização expirada",
};

export const PRESTAMISTA_STATUS_DISPLAY: Record<PRESTAMISTA_STATUS, string> = {
  [PRESTAMISTA_STATUS.PENDENTE]: "Formalização Pendente",
  [PRESTAMISTA_STATUS.CONCLUIDO]: "Concluido",
  [PRESTAMISTA_STATUS.CANCELADO]: "Cancelado",
  [PRESTAMISTA_STATUS.APROVADO_FORMALIZACAO]: "Aceito pelo cliente",
  [PRESTAMISTA_STATUS.REMOVIDO_FORMALIZACAO]: "Removido na Formalização",
};

export const DUE_DATE_RULE_DISPLAY: Record<DUE_DATE_RULE, string> = {
  [DUE_DATE_RULE.reverse_fifth_business_day]: "5º dia útil reverso",
  [DUE_DATE_RULE.reverse_fourth_business_day]: "4º dia útil reverso",
  [DUE_DATE_RULE.reverse_third_business_day]: "3º dia útil reverso",
  [DUE_DATE_RULE.reverse_second_business_day]: "2º dia útil reverso",
  [DUE_DATE_RULE.reverse_first_business_day]: "1º dia útil reverso",
  [DUE_DATE_RULE.first_business_day]: "1º dia útil",
  [DUE_DATE_RULE.second_business_day]: "2º dia útil",
  [DUE_DATE_RULE.third_business_day]: "3º dia útil",
  [DUE_DATE_RULE.fourth_business_day]: "4º dia útil",
  [DUE_DATE_RULE.fifth_business_day]: "5º dia útil",
};

export { PRODUCT_STATUS };
